// extracted by css-extract-rspack-plugin
export default {"cls1":"AdminBarActivator-cls1_R4B","cls2":"AdminBarActivator-cls2_N1N AdminBarActivator-cls1_R4B"};